import React from 'react';

import { Popover as NBPopover } from 'native-base';
import type { IPopoverType } from './Popover.types';
import PopoverContent from './PopoverContent';

const Popover: IPopoverType = ({ children, ...props }) => {
  return (
    <NBPopover {...props}>
      <NBPopover.Content>
        <NBPopover.Arrow />
        {children}
      </NBPopover.Content>
    </NBPopover>
  );
};

Popover.Content = PopoverContent;

export default Popover;
